module.exports = __webpack_public_path__ + "static/media/Niveau_elN1_1_712828.a9c07edb.png";